import setFieldValue from "@iewccouk/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewccouk/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
} from "@iewccouk/Widgets/CreateAccount/FormBaseComponent";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Checkbox from "@insite/mobius/Checkbox/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup/CheckboxGroup";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const PreviouslyPurchasedWidget: React.FC<Props> = ({ previouslyPurchased, setFieldValue: widgetSetFieldValue }) => {
    const label = "Has your company previously purchased from IEWC?";
    const isRequired = false;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");
    const [isPreviouslyPurchasedd, setIsPreviouslyPurchasedd] = React.useState(false);

    const validateFieldBy = () => {
        const errorMessage =
            isRequired && !previouslyPurchased ? (siteMessage("RequestQuoteForm_PreviouslyPurchasedRequired", label) as string) : "";
        setFieldErrorMessage(errorMessage);
        return !errorMessage;
    };

    setRequestFormEffects(isRequired, previouslyPurchased, "previouslyPurchased", validateFieldBy);

    const fieldChangeHandler = (value: boolean) => {
        setIsPreviouslyPurchasedd(value);
        widgetSetFieldValue({ key: "previouslyPurchased", value: `${value}` });
    };

    return (
        <CheckboxGroup error={fieldErrorMessage}>
            <Checkbox
                checked={isPreviouslyPurchasedd}
                onChange={(_, value) => fieldChangeHandler(value)}
            >
                {translate(label)}
                {isRequired && <>*</>}
            </Checkbox>
        </CheckboxGroup>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviouslyPurchasedWidget);
